import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        SharedModule,
        NgxSmartModalModule.forRoot()],
    declarations: [SidebarComponent],
    exports: [SidebarComponent]
})

export class PolenSidebarModule { }
